/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  ListDocumentsQueryResponse,
  ListDocumentsQueryParams,
} from '../../types/ListDocuments'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listDocuments } from '../../clients/listDocuments'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listDocumentsQueryKey = (params?: ListDocumentsQueryParams) =>
  [{ url: '/api/v1/documents/' }, ...(params ? [params] : [])] as const

export type ListDocumentsQueryKey = ReturnType<typeof listDocumentsQueryKey>

export function listDocumentsQueryOptions(
  params?: ListDocumentsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = listDocumentsQueryKey(params)
  return queryOptions<
    ListDocumentsQueryResponse,
    ResponseErrorConfig<Error>,
    ListDocumentsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listDocuments(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @description ViewSet for document operations.
 * Uses hybrid architecture:
 * - READ operations (list, quota): Uses DRF ModelViewSet with filtering/sorting ecosystem
 * - WRITE operations (create, update, replace, delete, bulk-assign-brand): Uses Use Case pattern
 * M1.4: Implements list, create, update, delete, and storage quota.
 * M1.5 (FIR-4393): Added replace endpoint for versioning with soft delete.
 * @summary List documents (paginated, filtered)
 * {@link /api/v1/documents/}
 */
export function useListDocuments<
  TData = ListDocumentsQueryResponse,
  TQueryData = ListDocumentsQueryResponse,
  TQueryKey extends QueryKey = ListDocumentsQueryKey,
>(
  params?: ListDocumentsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListDocumentsQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? listDocumentsQueryKey(params)

  const query = useQuery(
    {
      ...listDocumentsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
